<script>
  // Right-side slide-over panel. `header` and `footer` snippets render OUTSIDE the
  // scrollable body — use them for controls that must stay visible while the content
  // scrolls (search bars, primary actions). `overModal` lifts a drawer opened from inside a
  // Modal above it (DaisyUI modals sit at z-index 999); other drawers stay below modals so a
  // confirm dialog opened from a drawer still shows on top.
  import Button from './ui/button.svelte'

  let { open = $bindable(false), title, width = 'w-96', overModal = false, header, footer, children } = $props()

  let uid = `admin-drawer-${Math.random().toString(36).slice(2)}`

  // Captured first so Escape closes only the drawer, not the Modal underneath it too. Escape
  // inside an open dropdown closes just that dropdown (it would lose the drawer's typed values).
  const onkeydowncapture = (event) => {
    if (!open || event.key !== 'Escape') return
    if (event.target instanceof Element && event.target.closest('.dropdown-open, [aria-expanded="true"]')) return
    open = false
    if (overModal) event.stopImmediatePropagation()
  }
</script>

<svelte:window {onkeydowncapture} />

<div class="drawer drawer-end">
  <input id={uid} type="checkbox" class="drawer-toggle" bind:checked={open} />

  <div class="drawer-side {overModal ? 'z-[1000]' : 'z-50'}">
    <label for={uid} aria-label="Close drawer" class="drawer-overlay" onclick={() => (open = false)}></label>

    <div class="bg-base-100 h-screen sticky top-0 {width} max-w-full flex flex-col border-l border-base-300">
      <div class="flex items-center justify-between p-4 border-b border-base-300 shrink-0">
        {#if title}<h2 class="text-lg font-semibold">{title}</h2>{/if}
        <Button variant="ghost" size="sm" circle icon="close" class="ml-auto" aria-label="Close drawer" onclick={() => (open = false)} />
      </div>

      {#if header}
        <div class="p-4 pb-3 border-b border-base-300 shrink-0">{@render header()}</div>
      {/if}

      <div class="flex-1 overflow-y-auto p-4">
        {@render children?.()}
      </div>

      {#if footer}
        <div class="p-4 border-t border-base-300 bg-base-100 shrink-0">{@render footer()}</div>
      {/if}
    </div>
  </div>
</div>
